<dgx-components-card
  *ngIf="modelNumberFinderContent"
  [dropShadow]="false"
  [theme]="'neutral-light-alternative'"
  class="appliance-details-stepped-form-find-model-serial-panel__card"
>
  <p class="typog-body-bold mb-4">{{ appliance }}</p>

  <div
    *ngFor="let image of modelNumberFinderContent.image"
    class="appliance-details-stepped-form-find-model-serial-panel__image-container mb-4"
  >
    <ng-container
      *ngIf="
        modelNumberFinderContent.image &&
        modelNumberFinderContent.image.length > 0
      "
    >
      <dgx-components-picture
        [alt]="'find-my-model-serial-number-helper'"
        [aspectRatio]="[271, 116]"
        [fit]="'fill'"
        src="assets/images/model-number-location/{{ image }}.jpg"
      />
    </ng-container>
  </div>

  <ng-container *ngIf="modelNumberFinderContent.content?.length">
    <ul
      *ngFor="let content of modelNumberFinderContent.content"
      class="appliance-details-stepped-form-find-model-serial-panel__list mt-2 ml-4"
    >
      <li
        class="appliance-details-stepped-form-find-model-serial-panel__list-item mt-2 mb-2"
      >
        {{ content }}
      </li>
    </ul>
  </ng-container>
</dgx-components-card>
